import { createSelector } from 'reselect';

export const getRawPath = (state) => state.routing.location.pathname;

const pathSplitter = (path) =>
  path
    .split('/')
    .slice(3)
    .join('/');

export const getPathname = createSelector([getRawPath], (rawPath) =>
  pathSplitter(rawPath)
);

//TODO: needed for redux-saga-router, the above selector throws an error on the first reload
export const getBrowserPathname = () => pathSplitter(window.location.pathname);



// WEBPACK FOOTER //
// ./src/actions/routes/routeSelectors.js